import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useUpdateCurrentUserMutation } from '../../../../lib/core/mutations';
import { useWizardContext } from '../../../../components/Wizard';
import { useToasts } from '../../../../components/Toasts';
import { CurrentUser } from '../../../../core-types';
import { Loading } from '../../../../components';
import {
  Container,
  Button,
  Flex,
  Text,
  Box,
  H1
} from '@urbaninfrastructure/react-ui-kit';
import { wallet } from '../messages';

type Props = {
  goNext: () => void;
  currentUser: CurrentUser;
};

export const EnableWallet = ({ goNext, currentUser }: Props) => {
  const { addToast } = useToasts();
  const [updateCurrentUser, { loading, error }] = useUpdateCurrentUserMutation({
    onCompleted: () => {
      addToast({
        text: <FormattedMessage {...wallet.enabled_succsessfully} />,
        type: 'success'
      });
    },
    onError: () => {
      addToast({
        text: error?.message || (
          <FormattedMessage {...wallet.generic_wallet_error} />
        ),
        type: 'error'
      });
    }
  });

  if (!currentUser) {
    return null;
  }

  if (loading) {
    return <Loading />;
  }

  const handleEnableWalletClick = () => {
    updateCurrentUser({
      variables: {
        input: {
          walletEnabled: true
        }
      }
    });
  };

  return (
    <Container variant="narrow" textAlign="center">
      <Box maxWidth="600px">
        <Box>
          <H1 typoStyle="lg">
            <FormattedMessage
              id="modules.Profile.Wallet.title"
              defaultMessage={'Wallet'}
            />
          </H1>
        </Box>

        <Text mb="xs">
          <FormattedMessage {...wallet.enable_wallet_description} />
        </Text>

        <Button
          shape="cool"
          variant="primary"
          mb="xs"
          mt="xs"
          onClick={() => {
            handleEnableWalletClick();
            goNext();
          }}
        >
          {' '}
          <Text>
            <FormattedMessage {...wallet.enable_wallet} />
          </Text>
        </Button>
      </Box>
    </Container>
  );
};

export function EnableWalletStep({
  currentUser
}: {
  currentUser: CurrentUser;
}) {
  const { goNext } = useWizardContext();
  return (
    <Flex flexDirection="column" alignItems="center" justifyContent="center">
      <EnableWallet goNext={goNext} currentUser={currentUser} />
    </Flex>
  );
}
